/**
 * Defines the `SelectionMode` of the AnalyticalTable.
 */
export let AnalyticalTableSelectionMode = /*#__PURE__*/function (AnalyticalTableSelectionMode) {
  AnalyticalTableSelectionMode["None"] = "None";
  AnalyticalTableSelectionMode["SingleSelect"] = "SingleSelect";
  AnalyticalTableSelectionMode["MultiSelect"] = "MultiSelect";
  return AnalyticalTableSelectionMode;
}({});